import { PointKind } from 'services/access-points/access-points.service';

// Qué puede decidir el usuario en cada tipo de punto. Es una tabla, no una
// cadena de ifs, porque el mismo dato gobierna tres cosas a la vez (el panel de
// Cambiar, la tercera línea de la tarjeta y el pie de la pantalla) y separarlas
// fue exactamente cómo se perdió una regla del mockup la vez anterior.
export interface PointCapabilities {
    canChooseStart: boolean;
    canChooseEnd: boolean;
    canChooseUses: boolean;
    // Duración que impone el hardware, en horas. Presente sólo cuando no es
    // negociable; su presencia es lo que habilita el aviso de "esto no se cambia".
    fixedHours?: number;
    deliveryKey: string; // tercera línea de la tarjeta: qué recibe la persona
    hintKey: string; // pie de la pantalla: por qué es así
    pickerSubtitleKey: string; // subtítulo de la fila en la lista de puntos
}

// keypad: la cerradura TTLock da 6 horas y una sola entrada
// (api/single_use_passes.go:119-122). No es configurable: ofrecer controles de
// vencimiento o de usos sería mentir con controles muertos.
const CAPABILITIES: Record<PointKind, PointCapabilities> = {
    keypad: {
        canChooseStart: true,
        canChooseEnd: false,
        canChooseUses: false,
        fixedHours: 6,
        deliveryKey: 'visit-access.delivery-keypad',
        hintKey: 'visit-access.hint-keypad',
        pickerSubtitleKey: 'visit-access.picker-sub-keypad',
    },
    reception: {
        canChooseStart: true,
        canChooseEnd: true,
        canChooseUses: true,
        deliveryKey: 'visit-access.delivery-reception',
        hintKey: 'visit-access.hint-reception',
        pickerSubtitleKey: 'visit-access.picker-sub-reception',
    },
};

export function capabilitiesFor(kind: PointKind): PointCapabilities {
    return CAPABILITIES[kind];
}
